import Link from 'next/link';
import { useRouter } from 'next/router';

import { Alert, ModalTrigger, TextButton } from '@zillow/constellation-10';

import { useGetListingDetails } from '../../../hooks/queries/properties';
import { getListingSourcesRoute } from '../../../constants/urls';

const FeedListingSourceBanner = () => {
  const router = useRouter();

  const listingAlias = router.query.listingAlias as string;

  const { data: listingDetails } = useGetListingDetails(listingAlias);

  const {
    adproduct: { isUnpaid = false } = {},
    feedName,
    isFeed,
    active,
    topDupesDetails: { hasManualDupe = false, sourceCount = 0 } = {},
  } = listingDetails ?? {};

  if (!isFeed) {
    return null;
  }

  let bodyText;
  let ctaText;
  if (!hasManualDupe) {
    bodyText = `This listing comes from ${feedName} and must be edited there`;
    if (!isUnpaid) {
      bodyText +=
        '. If you’d like to use Zillow Rental Manager to edit and manage your listing instead, copy and publish your listing.';
      ctaText = 'Automatically copy and create a new version';
    }
  } else if (active) {
    bodyText = `${feedName} is the source for this version of the listing,
            which is currently visible to renters. To change the listing source,
            publish the version of the listing you want users to see.`;
    ctaText = 'Manage listing sources';
  } else {
    bodyText = `${feedName} is the source for this version of the listing,
            which is not currently visible to renters. The address has ${sourceCount} listing sources.`;
    ctaText = 'Manage listing sources';
  }

  const cta = ctaText ? (
    hasManualDupe ? (
      <TextButton asChild>
        <Link href={getListingSourcesRoute({ listingAlias })}>{ctaText}</Link>
      </TextButton>
    ) : (
      <TextButton>{ctaText}</TextButton>
    )
  ) : null;

  return (
    <Alert
      tone="info"
      actionButton={
        !hasManualDupe ? <ModalTrigger multiModalTriggerId="TransferFeedListingModal">{cta}</ModalTrigger> : cta
      }
      css={{ marginBottom: '600' }}
    >
      {bodyText}
    </Alert>
  );
};

export { FeedListingSourceBanner };
export default FeedListingSourceBanner;
